import { render, staticRenderFns } from "./ProlificFinish.vue?vue&type=template&id=2b3c4bc5"
import script from "./ProlificFinish.vue?vue&type=script&lang=js"
export * from "./ProlificFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports